import {
    AnalyticsApp,
    AnalyticsEvent,
    AnalyticsPlatform,
    type FoodLogMethod,
    type PremiumStatusId,
} from '@focuslee/shared';

export const AnalyticsEventType = {
    PAGE_VIEWED: AnalyticsEvent.pageViewed,

    QUEST_CREATED: 'Quest Created',
    QUEST_UPDATED: 'Quest Updated',
    QUEST_COMPLETED: 'Quest Completed',
    QUEST_ABANDONED: AnalyticsEvent.questAbandoned,

    SWITCH_FOCUS: 'Switch Focus',

    ACHIEVEMENT_CREATED: 'Achievement Created',
    ACHIEVEMENT_UPDATED: 'Achievement Updated',

    CATEGORY_CREATED: 'Category Created',
    CATEGORY_UPDATED: 'Category Updated',

    REWARD_CREATED: 'Reward Created',
    REWARD_UPDATED: 'Reward Updated',
    REWARD_PURCHASED: 'Reward Purchased',

    MINI_APP_OPENED: AnalyticsEvent.miniAppOpened,
    ONBOARDING_STEP_COMPLETED: AnalyticsEvent.onboardingStepCompleted,
    ONBOARDING_COMPLETED: AnalyticsEvent.onboardingCompleted,
    VOICE_COMMAND_STARTED: AnalyticsEvent.voiceCommandStarted,
    VOICE_COMMAND_SUCCEEDED: AnalyticsEvent.voiceCommandSucceeded,
    VOICE_COMMAND_FAILED: AnalyticsEvent.voiceCommandFailed,
    PAYWALL_VIEWED: AnalyticsEvent.paywallViewed,
    CHECKOUT_STARTED: AnalyticsEvent.checkoutStarted,
    CROSS_SELL_SHOWN: AnalyticsEvent.crossSellShown,
    CROSS_SELL_CLICKED: AnalyticsEvent.crossSellClicked,
} as const;

export const AnalyticsApps = AnalyticsApp;
export const AnalyticsPlatforms = AnalyticsPlatform;

export type { FoodLogMethod, PremiumStatusId };
